import { routes } from "constants/routes";
import Login from "containers/Auth/Login";
import PrivateRoutes from "containers/Auth/PrivateRoutes";
import VerifyAuth from "containers/Auth/VerifyAuth";
import ChooseBusiness from "containers/ChooseBusiness";
import Home from "containers/Home";
import PaymentMethodManagement from "containers/PaymentMethodManagement/PaymentMethodManagement";
import Purchase from "containers/Purcahase";
import TopupHistory from "containers/TopupHistory";
import TransactionStatus from "containers/TransactionStatus/TransactionStatus";

import { Route, Routes } from "react-router-dom";

const RootRoutes = () => {
  return (
    <Routes>
      {/* Protected Routes */}
      <Route element={<PrivateRoutes />}>
        <Route path={routes.home} element={<Home />} />
        <Route path={routes.topupHistory} element={<TopupHistory />} />
        <Route
          path={`${routes.chooseBusiness}/:businessId`}
          element={<ChooseBusiness />}
        />
        <Route path={routes.purchase} element={<Purchase />} />
        <Route
          path={routes.paymentManagement}
          element={<PaymentMethodManagement />}
        />
        <Route
          path={routes.transactionStatus}
          element={<TransactionStatus />}
        />
      </Route>
      {/* Presignin rotes */}
      <Route path={routes.login} element={<Login />} />
      <Route path={routes.verifyAuth} element={<VerifyAuth />} />
    </Routes>
  );
};

export default RootRoutes;
